"use client";
import SectionPage from "@/components/common/section-page";

import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import {PageEnConstruction} from "@/components/common/page-en-construction";

export default function Home() {

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"Veille"}
                                middleBreadcrumbs={[
                                    {title: "Pôle de l’Observation et des Etudes", link: "/espace-pro/pole-observation-etudes"},
                                ]}
                                description={"L’approche du tourisme est économique et sous cet angle, le tourisme s’entend des activités des personnes appelées visiteurs."}/>

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">

               <PageEnConstruction />
            </SectionPage>

        </div>
    );
}
